import BaseRestService from './baseRestService';

const _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.EventRestService
 *
 * @description
 * This class contains methods used to retrieve/add information about events
 * using http requests.
*/
export default class EventRestService extends BaseRestService {

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    constructor($http, $q, Util) {

        super($http, $q, Util);

    }

    getByDevice(deviceId) {

        return super.getAllAsync(`events/?filter[device]=${deviceId}`);

    }

    /**
     * @ngdoc function
     * @name rest.services.EventRestService#getAllAsync
     * @methodOf rest.services.EventRestService
     * @function
     *
     * @description
     * Retrieves all events.
     *
     * @returns {Promise} The promise of the call.
     */
    getAllAsync() {

        return super.getAllAsync('events/');

    }

}

_serviceDependencies.push(EventRestService);

angular.module('rest.services')
    .service('EventRestService', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/restServices/eventRestService.js